import { useEffect } from "react";
import { useScheduleContext } from "./context/useScheduleContext";

export const useDragAndDropCopyModifier = () => {
    const { selectedCellOrEvent, dispatch } = useScheduleContext();

    useEffect(() => {
        const updateModifierState = (e: KeyboardEvent) => {
            const tagName = (e.target as HTMLElement)?.tagName?.toLowerCase();
            if (["input", "textarea", "select"].includes(tagName) || (e.target as HTMLElement)?.isContentEditable) {
                return;
            }
            const copyActive = e.getModifierState("Control") || e.getModifierState("Meta");
            dispatch({ type: "drag-and-drop-copy", payload: copyActive });
        };

        const resetState = () =>  dispatch({ type: "drag-and-drop-copy", payload: false });

        if (!selectedCellOrEvent) {
            window.addEventListener("keydown", updateModifierState);
            window.addEventListener("keyup", updateModifierState);
            window.addEventListener("blur", resetState);
            document.addEventListener("visibilitychange", () => {
                if (document.hidden) resetState();
            });
        }

        return () => {
            window.removeEventListener("keydown", updateModifierState);
            window.removeEventListener("keyup", updateModifierState);
            window.removeEventListener("blur", resetState);
            document.removeEventListener("visibilitychange", resetState);
        };
    }, [selectedCellOrEvent, dispatch]);
}
